/** Parent / Carer complimentary adult — only shown on a valid one-use choir booking link. */
export const CHOIR_FREE_ADULT_PRODUCT_CODE = 'ADMISS00258';

export function isChoirFreeAdultTicket(item) {
  if (!item) return false;
  const code = String(
    item.productCode || item.ProductCode || item.code || item.sku || ''
  )
    .trim()
    .toUpperCase();
  if (code === CHOIR_FREE_ADULT_PRODUCT_CODE) return true;
  const name = String(item.name || item.title || '').toLowerCase();
  return name.includes('parent') && name.includes('carer') && name.includes('free');
}
